/* eslint-disable */
import { useRef, useState } from "react";
import { Carousel } from "antd";
import { LeftCircleFilled, RightCircleFilled } from "@ant-design/icons";
import styled from "styled-components";
import Figure from "@/assets/images/figure.png";
import Figure2 from "@/assets/images/figure2.png";
import Figure3 from "@/assets/images/figure3.png";
import Figure4 from "@/assets/images/figure4.png";
import Figure5 from "@/assets/images/figure5.png";
import Figure6 from "@/assets/images/figure6.png";
export default () => {
  const carouselRef = useRef();
  // const imgList = [Figure, Figure2, Figure3, Figure4];
  const imgList = [Figure5, Figure6];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleAfterChange = (index) => {
    setCurrentIndex(index);
  };

  const left = () => {
    carouselRef.current.prev();
  };
  const right = () => {
    carouselRef.current.next();
  };
  return (
    <Warper>
      <Carousel autoplay ref={carouselRef} afterChange={handleAfterChange}>
        {imgList.map((URL, index) => {
          return (
            <div className="item">
              <img src={URL} style={{ width: "680px", height: "400px" }}></img>
              <div className="name">欢迎来到紫东太初数字人创作平台</div>
              <div className="handle">
                <LeftCircleFilled
                  className="left"
                  onClick={left}
                  style={{ color: index !== 0 ? "#1e86ff" : "#666666" }}
                />
                <div className="introduce">
                  紫东太初数字人创作平台是一个集数字人设计、制作、应用及优化于一体的综合性平台，旨在为用户提供从创意构思到最终应用的全方位、一站式的数字人创作服务。通过集成先进的人工智能技术、高效的创作工具和丰富的应用场景，平台致力于降低数字人创作的门槛，提升创作效率，同时确保数字人形象的高保真度和互动性。
                </div>
                <RightCircleFilled
                  className="right"
                  onClick={right}
                  style={{
                    color: imgList.length !== index + 1 ? "#1e86ff" : "#666666",
                  }}
                />
              </div>
            </div>
          );
        })}
      </Carousel>
    </Warper>
  );
};

const Warper = styled.div`
  width: 680px;
  display: flex;
  justify-content: center;
  align-items: center;
  .slick-list {
    width: 680px;
  }
  .slick-dots {
    li.slick-active {
      button {
        width: 20px;
        height: 100%;
        border-radius: 20%;
        background: #1e86ff;
      }
    }
    li {
      width: 4px;
      height: 4px;
      border-radius: 100%;
      button {
        background: #b5bcc2;
        width: 4px;
        height: 4px;
        border-radius: 100%;
      }
    }
  }
  .slick-dots-bottom {
    bottom: -20px;
  }
  .item {
    width: 680px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .name {
      color: #1f1f1f;
      font-family: Source Han Sans CN;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      margin-top: 40px;
    }
    .handle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 40px;
    }
    .introduce {
      margin: 0 auto;
      font-family: Source Han Sans CN;
      font-size: 14px;
      font-weight: 350;
      line-height: 24px;
      letter-spacing: -0.01em;
      text-align: center;
      color: #666666;
      padding: 20px 20px;
    }
    .left,
    .right {
      color: #666666;
      opacity: 0.6;
      font-size: 36px;
      &:hover {
        color: #1e86ff;
        cursor: pointer;
      }
    }
  }
`;
